// extracted by mini-css-extract-plugin
export default {"ChatStudentBadge":"ChatStudentBadge_ChatStudentBadge__5R3sV"};